import { DatePicker, Table, TableColumnsType } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Button from '../../../components/Button';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import config from '../../../lib/config';
import DownloadButton from '../../../components/DownloadButton';
import Pagination from '../../../components/Pagination';
import SearchExamineeModal from '../../../components/modals/SearchExamineeModal';
import EditExamScheduleModal from '../../../components/entrance/schedule/modals/EditExamScheduleModal';
import SmsGuideModal from '../../../components/entrance/schedule/modals/SmsGuideModal';
import useAxios from '../../../hooks/useAxios';
import { IEntranceSchedule, IEntranceScheduleByDateReq, IGetEntranceSchedules } from '../../../models/placeTest.model';
import { useHistory, useLocation } from 'react-router';
import QueryString from 'qs';
import { getEntranceSchedules, getEntranceSchedulesByDate } from '../../../api/placeTest.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import _ from 'lodash';
import { getDayOfWeek } from '../../../lib/util';
import SelectCampus from '../../../components/SelectCampus';
import useAuth from '../../../hooks/useAuth';
import exportTable from '../../../lib/exportTable';
import DeleteExamScheduleModal from '../../../components/entrance/schedule/modals/DeleteExamScheduleModal';
import useUtil from '../../../hooks/useUtil';
import SelectEduStep from '../../../components/SelectEduStep';
import { getCommonCodeLabel } from '../../../lib/store';

const EntranceSchedule = () => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const { isCampusDeactived } = useUtil();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetEntranceSchedules>();

  const [data, setData] = useState<IEntranceSchedule[]>([]);
  const [record, setRecord] = useState<IEntranceSchedule>();
  const [eduStepCode, setEduStepCode] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [SearchExamineeVisible, setSearchExamineeVisible] = useState(false);
  const [createExamScheduleVisible, setCreateExamScheduleVisible] = useState(false);
  const [updateExamScheduleVisible, setUpdateExamScheduleVisible] = useState(false);
  const [deleteExamScheduleVisible, setDeleteExamScheduleVisible] = useState(false);
  const [smsGuideVisible, setSmsGuideVisible] = useState(false);
  const [campusDeactived, setCampusDeactived] = useState(false);
  const [page, setPage] = useState(1);
  const [param, setParam] = useState({});

  useEffect(() => {
  }, [record]);

  useEffect(() => {
    getSchedules();
  }, [currentCampus]);

  useEffect(() => {
    setCampusDeactived(isCampusDeactived());
  }, [isCampusDeactived]);

  useEffect(() => {
    if (res && !isLoading) {
      // query to state
      const _param: any = {};

      if (query.eduStepCode) {
        _param.eduStepCode = String(query.eduStepCode);
        setEduStepCode(_param.eduStepCode);
      }
      
      if (query.startDate && query.endDate) {
        _param.startDate = String(query.startDate);
        _param.endDate = String(query.endDate);
        //setStartDate(_param.startDate);
        //setEndDate(_param.endDate);
      } else {
        const _startDate = moment().format('YYYYMMDD');
        const _endDate = moment().add(1, 'months').format('YYYYMMDD');
        _param.startDate = _startDate;
        _param.endDate = _endDate;
        //setStartDate(_startDate);
        //setEndDate(_endDate);
      }
      if (query.page) {
        _param.page = Number(query.page);
        setPage(_param.page);
      }

      setParam(_param);

      // data filtering
      let data: IEntranceSchedule[] = _.cloneDeep(res.data);

      if (_param.eduStepCode) {
        data = data.filter(item => item.eduStepCode === _param.eduStepCode);
      }
      /*
      if (_param.startDate && _param.endDate) {
        data = data.filter(item => {
          return moment(item.examDate).isBetween(
            moment(_param.startDate).subtract(1, 'days'),
            moment(_param.endDate).add(1, 'days'),
          );
        });
      }
      */

      setData(data);
    }
  }, [res, isLoading, location]);

  const getSchedules = () => {
    if (!currentCampus) return;
    //execute(getEntranceSchedules(currentCampus));
    const _param: any = {};
    
    if (startDate && endDate) {
      _param.srtDate = startDate;
      _param.endDate = endDate;
    } else {
      if (query.startDate && query.endDate) {
        _param.srtDate = String(query.startDate);
        _param.endDate = String(query.endDate);
      } else {
        const _startDate = moment().format('YYYYMMDD');
        const _endDate = moment().add(1, 'months').format('YYYYMMDD');

        _param.srtDate = _startDate;
        _param.endDate = _endDate;
      }
      
      setStartDate(_param.srtDate);
      setEndDate(_param.endDate);
    }

    execute(getEntranceSchedulesByDate(currentCampus, _param));
  }

  const onSearch = () => {
    const param: any = { page: 1 };

    if (eduStepCode) {
      param.eduStepCode = eduStepCode;
    }
    if (startDate && endDate) {
      param.startDate = startDate;
      param.endDate = endDate;
    }

    getSchedules();
    setParam(param);
    history.push(`/entrance/schedule?${QueryString.stringify(param)}`);
  }

  const onExportTable = () => {
    const currentDate = moment(new Date());
    exportTable(columns.slice(0, -1), data, `${t('entrance.schedule.7')}_(${currentDate.format('YYYYMMDD')})`, t('entrance.schedule.7'), [15, 12, 10, 12, 12, 12, 12]);
  }

  const columns: TableColumnsType<IEntranceSchedule> = [
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => getCommonCodeLabel('PR0006', value, i18n.language),
    },    
    {
      title: t('entrance.schedule.column1'),
      dataIndex: 'examDate',
      key: 'examDate',
      align: 'center',
      sorter: (a, b) => a.examDate?.localeCompare(b.examDate),
      render: (value) => `${moment(value).format('YYYY.MM.DD')}(${getDayOfWeek(value)})`
    },
    {
      title: t('entrance.schedule.column2'),
      dataIndex: 'srtTime',
      key: 'srtTime',
      align: 'center',
      sorter: (a, b) => a.srtTime?.localeCompare(b.srtTime),
    },
    {
      title: t('entrance.schedule.column3'),
      key: 'quota',
      dataIndex: 'quota',
      align: 'center',
      sorter: (a, b) => a.quota - b.quota,
      render: (value) => value === 0 ? t('entrance.schedule.text1') : value
    },
    {
      title: t('entrance.schedule.column4'),
      key: 'applyCnt',
      dataIndex: 'applyCnt',
      align: 'center',
      sorter: (a, b) => a.applyCnt - b.applyCnt,
    },
    {
      title: t('entrance.schedule.column5'),
      key: 'payCnt',
      dataIndex: 'payCnt',
      align: 'center',
      sorter: (a, b) => a.payCnt - b.payCnt,
    },
    {
      title: t('entrance.schedule.column6'),
      key: 'testCnt',
      dataIndex: 'testCnt',
      align: 'center',
      sorter: (a, b) => a.testCnt - b.testCnt,
    },
    {
      title: t('entrance.schedule.column42'),
      key: 'registCnt',
      dataIndex: 'registCnt',
      align: 'center',
      sorter: (a, b) => a.registCnt - b.registCnt,
    },
    {
      title: t('entrance.statistics.column7'),
      key: 'registRate',
      dataIndex: 'registRate',
      align: 'center',
      sorter: (a, b) => a.registRate - b.registRate,
      render: (value) => value + '%'
    },
    {
      title: t('entrance.schedule.column7'),
      key: 'openYn',
      dataIndex: 'openYn',
      align: 'center',
      sorter: (a, b) => a.openYn?.localeCompare(b.openYn),
    },
    {
      title: t('entrance.schedule.8'),
      key: 'closeYn',
      dataIndex: 'closeYn',
      align: 'center',
      sorter: (a, b) => a.openYn?.localeCompare(b.openYn),
    },
    {
      title: t('common.button.edit'),
      key: 'platScheduleCode',
      dataIndex: 'platScheduleCode',
      align: 'center',
      sorter: (a, b) => a.testCnt - b.testCnt,
      render: (value, record) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small pink-line"
            onClickCapture={e => {
              e.stopPropagation();
              setRecord(record);
              setUpdateExamScheduleVisible(true);
            }}
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      )
    },
    {
      title: t('common.button.delete'),
      key: 'platScheduleCode',
      dataIndex: 'platScheduleCode',
      align: 'center',
      sorter: (a, b) => a.testCnt - b.testCnt,
      render: (value, record) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small gray"
            onClickCapture={e => {
              e.stopPropagation();
              setRecord(record);
              setDeleteExamScheduleVisible(true);
            }}
            text={t('common.button.delete')}
            writeAuthYn={writeAuthYn}
            disabled={record.applyCnt > 0}
          />
        </div>
      )
    }
  ];

  return (
    <>
    <SimpleHeader
      parentMenu={t('common.menu.placementTest')}
      currentMenu={t('entrance.schedule.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('common.placeholder.1')}</label>
            <div>
              <SelectEduStep
                eduStepCode={eduStepCode}
                setEduStepCode={setEduStepCode}
                includeAll
                fullWidth
              />
            </div>
          </li>
          <li>
            <label>{t('entrance.schedule.column1')}</label>
            <div className="date-picker__area">
              <DatePicker
                value={startDate ? moment(startDate) : undefined}
                onChange={e => {
                  if (e === null) setStartDate('');
                  else setStartDate(moment(e).format('YYYYMMDD'))
                }}
              />
            </div>
            ~
            <div className="date-picker__area">
              <DatePicker
                value={endDate ? moment(endDate) : undefined}
                onChange={e => {
                  if (e === null) setEndDate('');
                  else setEndDate(moment(e).format('YYYYMMDD'))
                }}
              />
            </div>
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
              <Button
                className="btn-basic black"
                onClick={() => setSearchExamineeVisible(true)}
                text={t('entrance.schedule.button1')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>	
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      
      <div className="comm-bx__between">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <DownloadButton
            onClick={onExportTable}
          />
          <span style={{ color: '#666', fontSize: '13px' }}>* 전날 20시에 입학시험 리마인드 문자가 발송됩니다.</span>
          <div
            onClick={() => setSmsGuideVisible(true)}
            style={{
              width: '25px',
              height: '25px',
              display: 'inline-block',
              background: '#fff',
              boxShadow: '1px 1px 3px rgba(0,0,0,.3)',
              border: '1px solid rgba(0,0,0,.3)',
              borderRadius: '30px',
              padding: '2px 0',
              fontSize: '15px',
              textAlign: 'center',
              cursor: 'pointer',
            }}
          >
            ❔
          </div>
        </div>
        <div className="comm-btn__area right">
          <Button
            className='btn-basic pink'
            onClick={() => setCreateExamScheduleVisible(true)}
            text={t('entrance.schedule.button2')}
            disabled={campusDeactived}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: config.pageSize
          }}
          onRow={record => {
            return {
              onClick: () => {
                if(query.startDate && query.endDate) {
                  history.push(`/entrance/schedule/${record.platScheduleCode}/examinee?startDate=${query.startDate}&endDate=${query.endDate}`);
                } else {
                  history.push(`/entrance/schedule/${record.platScheduleCode}/examinee`);
                }
              }
            };
          }}
          rowClassName="pointer"
          rowKey="platScheduleCode"
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton
          onClick={onExportTable}
        />
        <div className="common-paging center">
          <Pagination
            count={data.length}
            page={page}
            param={param}
            path="/entrance/schedule"
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className='btn-basic pink'
            onClick={() => setCreateExamScheduleVisible(true)}
            text={t('entrance.schedule.button2')}
            disabled={campusDeactived}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>

      {SearchExamineeVisible && (
        <SearchExamineeModal
          visible={SearchExamineeVisible}
          setVisible={setSearchExamineeVisible}
        />
      )}
      {createExamScheduleVisible && (
        <EditExamScheduleModal
          visible={createExamScheduleVisible}
          setVisible={setCreateExamScheduleVisible}
          getSchedules={getSchedules}
        />
      )}
      {updateExamScheduleVisible && (
        <EditExamScheduleModal
          visible={updateExamScheduleVisible}
          setVisible={setUpdateExamScheduleVisible}
          getSchedules={getSchedules}
          record={record}
        />
      )}
      {deleteExamScheduleVisible && (
        <DeleteExamScheduleModal
          visible={deleteExamScheduleVisible}
          setVisible={setDeleteExamScheduleVisible}
          getSchedules={getSchedules}
          record={record}
        />
      )}
      {smsGuideVisible && (
        <SmsGuideModal
          visible={smsGuideVisible}
          setVisible={setSmsGuideVisible}
        />
      )}
    </div>
    </>
  );
}

export default EntranceSchedule;
